import { format } from 'date-fns';
import type { CalendarEventDateInput } from '../types';

/**
 * Builds the discriminated date shape the API expects — `date` when all-day,
 * `instant` + `timeZoneId` otherwise. Both are required together for timed
 * events (`CalendarEvent.InvalidDate` otherwise) — `timeZoneId` should be the
 * user's configured timezone (`useUIStore().timezone`), not omitted.
 */
export function toCalendarEventDateInput(
  date: Date,
  allDay: boolean,
  timeZoneId?: string,
): CalendarEventDateInput {
  return allDay
    ? { date: format(date, 'yyyy-MM-dd') }
    : { instant: date.toISOString(), timeZoneId };
}
